import React, { useEffect, useState } from 'react';
import { RefreshCw, Save, Loader2 } from 'lucide-react';
import { adminApi } from '../../api';
import { PageHeader, Field, Input } from './AdminUI';

const KNOWN = ['USD', 'GBP', 'CHF'];

export default function AdminCurrency() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [rates, setRates] = useState({ USD: '', GBP: '', CHF: '' });
  const [manual, setManual] = useState(false);

  const load = async () => {
    const d = await adminApi.currencyRates();
    setData(d);
    setRates({ USD: d.rates?.USD ?? '', GBP: d.rates?.GBP ?? '', CHF: d.rates?.CHF ?? '' });
    setManual(!!d.manual_override);
  };
  useEffect(() => { load(); }, []);

  const refresh = async () => {
    setBusy(true); setMsg('');
    try { await adminApi.refreshCurrencyRates(); await load(); setMsg('Tassi aggiornati da frankfurter.app ✓'); }
    catch (e) { setMsg('Errore refresh: ' + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  const saveManual = async () => {
    setBusy(true); setMsg('');
    try {
      const payload = {};
      KNOWN.forEach(k => { if (rates[k] !== '' && !isNaN(Number(rates[k]))) payload[k] = Number(rates[k]); });
      await adminApi.setCurrencyRates(payload, manual);
      await load();
      setMsg('Tassi salvati ✓');
    } catch (e) { setMsg('Errore: ' + (e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader title="Cambio valuta"
        subtitle="Tassi in tempo reale usati per convertire i prezzi mostrati ai turisti. Base: EUR. Aggiornati automaticamente ogni 24h da frankfurter.app."
        action={<button onClick={refresh} disabled={busy} className="btn-primary flex items-center gap-2" data-testid="admin-currency-refresh"><RefreshCw size={16} className={busy ? 'animate-spin' : ''}/> Aggiorna ora</button>}
      />

      {msg && <div className="mb-4 px-3 py-2 rounded bg-emerald-50 text-emerald-800 text-sm">{msg}</div>}

      {data && (
        <div className="bg-white border border-gray-200 rounded-xl p-6 max-w-2xl">
          <div className="grid grid-cols-2 gap-4 text-sm mb-6">
            <div><span className="text-gray-500">Aggiornato:</span> <span className="font-mono">{data.updated_at ? new Date(data.updated_at).toLocaleString('it-IT') : '—'}</span></div>
            <div><span className="text-gray-500">Fonte:</span> <span className="font-semibold">{data.source}</span></div>
          </div>

          <h3 className="font-semibold text-gray-800 mb-3">1 EUR =</h3>
          <div className="space-y-3">
            {KNOWN.map(k => (
              <Field key={k} label={k}>
                <Input type="number" step="0.0001" value={rates[k]} onChange={e => setRates({...rates, [k]: e.target.value})} data-testid={`currency-rate-${k}`}/>
              </Field>
            ))}
          </div>

          <label className="flex items-center gap-2 text-sm mt-4">
            <input type="checkbox" checked={manual} onChange={e => setManual(e.target.checked)}/>
            <span>Blocca su valori manuali (non aggiornare dall'API automatica)</span>
          </label>

          <div className="mt-6 flex gap-2">
            <button onClick={saveManual} disabled={busy} className="btn-primary flex items-center gap-2" data-testid="admin-currency-save">
              {busy ? <Loader2 size={14} className="animate-spin"/> : <Save size={14}/>} Salva tassi manuali
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
